import { render } from "./EditHyperlinks.vue?vue&type=template&id=ead05bec&scoped=true"
const script = {}

import "./EditHyperlinks.vue?vue&type=style&index=0&id=ead05bec&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ead05bec"]])

export default __exports__